import { createMaterialBalance } from "@/services/project/material-balance.service"
import { Form, Input, Modal, ModalProps } from "antd"
import TextArea from "antd/es/input/TextArea"
import { createRoot } from "react-dom/client"

interface AddMaterialBalanceModalProps extends ModalProps {
  pId: string
  onSuccess?: () => void
  onCancel?: () => void
}

export const AddMaterialBalanceModal = (props: AddMaterialBalanceModalProps) => {
  const {onCancel, pId, onSuccess} = props;
  const [form] = Form.useForm()
  
  const onSave = async (values) => {
    await createMaterialBalance({...values, streams: []}, {params:{pId}})
    onSuccess?.()
  }

  return <Modal
    {...props}
    width={660}
    maskClosable={false}
    okText="Save"
    open
    onOk={() => form.submit()}
    onCancel={onCancel}
  >
    <div>New Material Balance</div>
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter material balance name' }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item label='Description' name='description'>
        <TextArea rows={3} />
      </Form.Item>
    </Form>
  </Modal>
}

AddMaterialBalanceModal.show = (props: AddMaterialBalanceModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<AddMaterialBalanceModal
    {...props}
    onCancel={() => {
      props.onCancel?.()
      root.unmount()
    }}
    onSuccess={() => {
      props.onSuccess?.()
      root.unmount()
    }}
  />);
}